import { countryCodesByAlpha3 } from "assets/country-codes/country-codes";
import { nationalitiesByAlpha3 } from "assets/country-codes/nationalities";
import Content, { ContentNS } from "content/content";
import { FC } from "react";

import Picker from "./Picker";

interface NationalityPickerProps {
  id: string;
  label?: string;
  error: string | null;
  onChange: (value: string) => void;
  onFocus?: () => void;
  value?: string | null;
  disabled?: boolean;
  placeholder?: string;
}

const NationalityPicker: FC<NationalityPickerProps> = ({
  id,
  label,
  disabled,
  value,
  error,
  placeholder,
  onChange,
  onFocus,
}) => {
  const textNationality = (s: string) =>
    Content.shared.t(s, { ns: ContentNS.nationalities });

  const nationalities = Object.keys(nationalitiesByAlpha3)
    .map((key) => [key.toUpperCase(), textNationality(key.toUpperCase())])
    .sort((a, b) => a[1].localeCompare(b[1]));

  const options = nationalities.map(([code, name]) => (
    <option key={code} value={code}>
      {name}
    </option>
  ));

  return (
    <Picker
      id={id}
      label={label}
      value={value}
      options={options}
      disabled={disabled}
      onChange={onChange}
      placeholder={placeholder}
      flagCode={countryCodesByAlpha3[value || ""]?.alpha2}
      error={error}
      onFocus={onFocus}
    />
  );
};

export default NationalityPicker;
